import React, { useState } from 'react';
import Footer from '../../../layout/Footer/Footer';
import { useAtom } from 'jotai';
import { companyAtom } from '../../../_atoms/company';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Button from '../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { userAtom } from '../../../_atoms/user';
import { APP_VERSION } from '../../../version'


const DefaultFooter = () => {
	const [user] = useAtom(userAtom)
	const [company] = useAtom(companyAtom)
	const [offerDialogOpen, setOfferDialogOpen] = useState(false)
	const { darkModeStatus } = useDarkMode()
	const [isLoading, setIsLoading] = useState(false)
	const date = new Date()

	const { token } = user

	const { t } = useTranslation()

	const offerDialogToggle = () => setOfferDialogOpen(!offerDialogOpen)

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col p-2'>
						<span className='fw-light'>2024 - {date.getFullYear()}, v-{APP_VERSION}</span>
					</div>
					<div className='col-auto p-2'>
						<a
							href='https://oxyfitpro.com'
							target="__blank"
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>Oxy Fit Pro - {company && company._id ? company.name : ""}</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
